const getFileNameFromUrl = (url: string): string => {
  try {
    const parsed = new URL(url)
    const segment = parsed.pathname.split('/').filter(Boolean).pop()
    if (segment) {
      return decodeURIComponent(segment)
    }
  } catch {
    // Некорректный URL — используем запасное имя файла
  }
  return 'download'
}

/**
 * Запускает скачивание файла по URL без открытия новой вкладки браузера.
 * Если API отдаёт имя файла — передавайте его в `fileName`; иначе берётся последний сегмент пути из URL.
 */
export const triggerDownloadFromUrl = (url: string, fileName?: string): void => {
  const trimmedUrl = url.trim()
  if (!trimmedUrl) {
    return
  }

  const resolvedFileName = fileName?.trim() || getFileNameFromUrl(trimmedUrl)

  const link = document.createElement('a')
  link.href = trimmedUrl
  link.download = resolvedFileName
  link.rel = 'noopener noreferrer'
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()

  queueMicrotask(() => {
    link.remove()
  })
}
